// Called by : src/App.vue (select-infos)

<template>
    <div class="dropdown">

        <button class="btn btn-outline-light dropdown-toggle py-2 px-4 txt_ombre_333 txt_size_125" role="button" id="dropdownMenuInfos" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="oi oi-info pr-2"></span>
            <span class="">{{ $t('infos.info') }}</span>
        </button>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuInfos">
            <a href="" id="nav_pge_about" class="dropdown-item" data-toggle="modal" data-target="#pge_about">
                <span class="oi oi-double-quote-serif-left mr-2"></span>
                {{ $t('infos.about') }}
            </a>

            <a href="" id="nav_pge_cgu" class="dropdown-item" data-toggle="modal" data-target="#pge_cgu">
                <span class="oi oi-script mr-2"></span>
                {{ $t('infos.cgu') }}
            </a>
            
            <a href="#" class="dropdown-item disabled" aria-disabled="true">
                <span class="oi oi-book mr-2"></span>
                {{ $t('infos.help') }}
            </a>
        </div>
        
    </div> <!-- .dropdown -->
</template>

<script>
export default {
    // void
}
</script>

<style scoped>
    /* void */
</style>



// WEBPACK FOOTER //
// src/components/header/SelectInfos.vue